type Props = {
    children: JSX.Element | JSX.Element[];
};

function PageWrapper({ children }: Props) {
    return <div id="main-divider">{children}</div>;
}

export default PageWrapper;
